import type { ScrollAreaProps } from '@radix-ui/react-scroll-area';
import { ScrollArea } from './ScrollArea';

type ScrollLayoutProps = {
  children: React.ReactNode;
  className?: string;
  enabled?: boolean;
  orientation?: 'horizontal' | 'vertical';
  scrollbarClassName?: string;
  thumbClassName?: string;
  type?: ScrollAreaProps['type'];
};

export const ScrollLayout = ({
  children,
  className,
  enabled = true,
  orientation,
  ...rest
}: ScrollLayoutProps) => {
  if (!enabled) {
    return <>{children}</>;
  }

  return (
    <ScrollArea orientation={orientation} className={className} {...rest}>
      {children}
    </ScrollArea>
  );
};
